import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { Grid, Typography } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon/SvgIcon';

const styles = {
  promotionDetailsItems: {
    alignItems: 'center',
    gap: '10px',
    marginBottom: '12px',
  },
  statTitle: {
    color: 'colors.neutral700',
  },
  noData: {
    color: 'colors.neutral700',
  },
} as const;

interface ActivePromotionDetailsProps {
  icon: typeof SvgIcon | (() => JSX.Element);
  title: string;
  value: string;
}

export const ActivePromotionDetails: React.FC<ActivePromotionDetailsProps> = memo((props) => {
  const Icon = props.icon;
  const intl = useIntl();

  return (
    <Grid container direction="row" sx={styles.promotionDetailsItems}>
      <Grid item>
        <Icon />
      </Grid>
      <Grid item>
        <Grid container direction="column">
          <Grid item>
            <Typography variant="bodyS" sx={styles.statTitle}>
              {props.title}
            </Typography>
          </Grid>
          <Grid item>
            {props.value === null || props.value === `0` ? (
              <Typography sx={styles.noData}>
                {intl.formatMessage({
                  id: 'components.activePromotionsGrid.statsTitles.noData',
                })}
              </Typography>
            ) : (
              <Typography>{props.value}</Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
